import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from '@/redux/modules/config';
import { getShippingAuctions } from './shippingAuctions.api';
import { ShippingAuctionPayload, ShippingAuctionResponse } from './shippingAuctions.types';

export const fetchShippingAuctions = createAsyncThunk<ShippingAuctionResponse['payload'], ShippingAuctionPayload>(
    'la/ui/shippingAuctions/fetchShippingAuctions',
    async (payload, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);

        const { payload: response } = await getShippingAuctions({
            authToken,
            deployment,
            payload,
        });
        return response;
    }
);
